import API from './api';

export async function getTeams(campaign) {
  const { data } = await API.get(`/teams`, { params: { campaign } });
  return data;
}
